module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-fill-703cefd0.svg";